var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendario1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4791 22H2.52089C1.13028 22 0 20.8697 0 19.4791V4.3541C0 2.96349 1.13028 1.83337 2.52089 1.83337H19.4791C20.8697 1.83337 22 2.96349 22 4.3541V19.4791C22 20.8697 20.8697 22 19.4791 22ZM2.52089 3.20837C1.88928 3.20837 1.375 3.72249 1.375 4.3541V19.4791C1.375 20.1107 1.88928 20.625 2.52089 20.625H19.4791C20.1107 20.625 20.625 20.1107 20.625 19.4791V4.3541C20.625 3.72249 20.1107 3.20837 19.4791 3.20837H2.52089Z",
    fill: "#2D3035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 8.70837H0.6875C0.307999 8.70837 0 8.40038 0 8.02087C0 7.64137 0.307999 7.33337 0.6875 7.33337H21.3125C21.692 7.33337 22 7.64137 22 8.02087C22 8.40038 21.692 8.70837 21.3125 8.70837Z",
    fill: "#2D3035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.271 5.5C4.89149 5.5 4.5835 5.192 4.5835 4.8125V0.6875C4.5835 0.307999 4.89149 0 5.271 0C5.6505 0 5.9585 0.307999 5.9585 0.6875V4.8125C5.9585 5.192 5.6505 5.5 5.271 5.5Z",
    fill: "#2D3035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.729 5.5C16.3495 5.5 16.0415 5.192 16.0415 4.8125V0.6875C16.0415 0.307999 16.3495 0 16.729 0C17.1085 0 17.4165 0.307999 17.4165 0.6875V4.8125C17.4165 5.192 17.1085 5.5 16.729 5.5Z",
    fill: "#2D3035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario1);
export default __webpack_public_path__ + "static/media/calendario 1.a86b0b3178f54169c05b72f6121cfaf1.svg";
export { ForwardRef as ReactComponent };